var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "ai-chat-input",
      class: { "ai-chat-input--dragover": _vm.isDragover },
      on: {
        dragover: function ($event) {
          $event.preventDefault()
          return _vm.onDragOver.apply(null, arguments)
        },
        dragleave: _vm.onDragLeave,
        drop: function ($event) {
          $event.preventDefault()
          return _vm.onDrop.apply(null, arguments)
        },
      },
    },
    [
      _c("input", {
        ref: "filePicker",
        staticClass: "d-none",
        attrs: { type: "file", multiple: "", accept: "image/*,.psd" },
        on: { change: _vm.onAttachFiles },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "ai-chat-input__editor" }, [
        _vm.files.length
          ? _c(
              "div",
              { staticClass: "ai-chat-input__preview" },
              _vm._l(_vm.files, function (file, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "ai-chat-input__item" },
                  [
                    _vm.isImage(file)
                      ? _c("img", {
                          staticClass: "ai-chat-input__item--image",
                          attrs: { src: file.preview, alt: "preview-img" },
                        })
                      : _c(
                          "div",
                          { staticClass: "ai-chat-input__item--file" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.truncateFileName(file.name)) +
                                "\n        "
                            ),
                          ]
                        ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "ai-chat-input__item--remove",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.removeFile(index)
                          },
                        },
                      },
                      [_c("i", { staticClass: "bi-x" })]
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ai-chat-input__editor-prompt-area" },
          [
            _c(
              "div",
              { staticClass: "ai-chat-input__icons" },
              [
                _c(
                  "button",
                  {
                    staticClass: "ai-chat-input__icon-btn",
                    attrs: {
                      type: "button",
                      title: "Upload from desktop",
                      disabled: _vm.disabled,
                    },
                    on: { click: _vm.openFilePicker },
                  },
                  [_c("i", { staticClass: "bi bi-paperclip" })]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "ai-chat-input__icon-btn",
                    attrs: {
                      type: "button",
                      title: "Select from folders",
                      disabled: _vm.disabled,
                    },
                    on: { click: _vm.openFileBrowser },
                  },
                  [_c("i", { staticClass: "bi bi-folder" })]
                ),
                _vm._v(" "),
                _c("ClipboardQuickInsertPopover", {
                  attrs: {
                    "trigger-class": "ai-chat-input__icon-btn",
                    disabled: _vm.disabled,
                  },
                  on: { select: _vm.onClipboardQuickInsert },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              ref: "editorPrompt",
              staticClass: "ai-chat-input__editor-prompt",
              attrs: {
                contenteditable: !_vm.disabled,
                "data-placeholder": !_vm.prompt.length ? "Ask Optix AI..." : "",
              },
              on: {
                input: _vm.onEditorInput,
                keydown: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleKeydown.apply(null, arguments)
                },
                paste: function ($event) {
                  $event.stopPropagation()
                  return _vm.handlePaste.apply(null, arguments)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "ai-chat-input__send",
                attrs: {
                  variant: "primary",
                  size: "sm",
                  disabled: _vm.disabled || _vm.prompt.length === 0,
                },
                on: { click: _vm.sendMessage },
              },
              [_c("i", { staticClass: "cil-send" })]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.isDragover
        ? _c("div", { staticClass: "ai-chat-input__overlay" })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }